import Back from './src/back';

export default Back;
